export const Marquee = ({ words = ["Accurate", "Growth", "Experience", "Trust"], tone = "dark" }) => {
  const isDark = tone === "dark";
  const line = [...words, ...words];
  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden py-10 select-none ${isDark ? "bg-navy-900" : "bg-offwhite"}`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {line.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span
                  className={`font-heading font-extrabold uppercase tracking-tight text-6xl sm:text-7xl lg:text-8xl px-8 ${
                    isDark ? "text-stroke" : "text-stroke-navy"
                  }`}
                >
                  {w}
                </span>
                <span className="text-emerald-brand text-5xl px-2">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
